import client from './client';

export const getConversationsApi = data =>
  client().get('/conversations', {
    params: data,
  });
export const createNewConversationApi = data => client().post('/conversations', data);
